import { createStore } from 'redux';
import * as api from '../api';
import * as api2 from '../api/index2.js'
import {CREATESTROKE, FETCH_ALLSTROKE, UPDATESTROKE, DELETESTROKE, STROKEPREDICTION, GET_TOTALPAGES} from '../constants/actionTypes';


// Action Creators
export const getStrokePosts = (pageNumber) => async(dispatch) => {
    try{
        const {data} = await api.fetchStrokePosts(pageNumber);
        dispatch(getTotalPages(data.totalPages))
        dispatch({type: FETCH_ALLSTROKE, payload: data.strokeMessages });
    } catch (error){
        console.log(error.message);
    }
}


export const createStrokePost = (strokepost) => async(dispatch) => {
    try{
        const {data} = await api.createStrokePost(strokepost);
        dispatch({type: CREATESTROKE, payload: data});
    } catch (error){
        console.log(error.message);
    }
}


export const updateStrokePost = (id, strokepost) => async(dispatch) => {
    try{
        const {data} = await api.updateStrokePost(id, strokepost);
        dispatch({type: UPDATESTROKE, payload: data});      
        //console.log("UpdateStroke", id)
        console.log("UpdateStroke",strokepost )
    } catch (error){
        console.log(error.message);
    }
}


export const deleteStrokePost = (id) => async(dispatch) => {
    try{
        const data = await api.deleteStrokePost(id);
        dispatch(getTotalPages(data.data.totalPages));
        dispatch({type: DELETESTROKE, payload: id});
    } catch(error){
        console.log(error.message);
    }
}


export const makeStrokePrediction = (strokePost)  => async(dispatch) =>{
    try{
        const {data} = await api2.strokePrediction(strokePost);
        if ('_id' in data){
            const id = data._id
            delete data._id
            dispatch(updateStrokePost(id, data))    
        }
        else{
            dispatch(createStrokePost({data}))
        }
        dispatch({type :  STROKEPREDICTION, payload : data});
                
    } catch(error){
        console.log(error.message);
    }
}


export const getTotalPages = (totalPages) => async(dispatch) => {
    try{
        dispatch({type: GET_TOTALPAGES, payload: totalPages });
    } catch (error){
        console.log(error.message);
    }
}